import React from 'react';
import Api from './Api';
import { useState, useEffect, Fragment } from 'react';

const Login = () => {

    const [ loginMessage, setLoginMessage ] = useState(null);
    const [ showLoginButton, setShowLoginButton ] = useState(true);

    const defaultLoginMessage = "As of May 2025, the RAC authentication mechanism has changed. The RAC now only accepts ORCID login. You will still get your ALSHub information loaded into the RAC. However, you will need to link your ORCID to your ALSHub account to be able to login.";


    const handleLogin = () => {

        const orcidAuthUrl = '/api/login_redirect';
        
        window.location.href = orcidAuthUrl;
    };


    const fetchLoginMessage = async () => {
        try {
          const res = await Api.get("/loginMessage.json");
          if (!res.ok) {
            throw new Error("Network response was not ok");
          }
          const data = await res.json();
          if (data.name === "Invalid Operation") {
            throw new Error("Invalid Operation");
          } else {
              console.log("Login message data:", data);
                if ('display' in data && data.display === true) {
                    if ('message' in data) {
                        setLoginMessage(data.message);
                    }
                }
                if ('showLoginButton' in data && data.showLoginButton === false) {
                    setShowLoginButton(false);
                }
          }
        } catch (error) {
          console.error("Error fetching login message:", error);
        }
      };

      useEffect(()=> {
        fetchLoginMessage();
      }, []);

    return (
        <article style={{
            textAlign: 'center',
            marginTop: '4rem',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            border: '0px solid #C1D3E3',
            borderRadius: '10px',
            padding: '20px',
            width: '100%',
            maxWidth: '500px',
            height: '500px',
            
        }}>
            <img src="/alsLogo.png" alt="als wheel logo" style={{ width: '10rem', height: '10rem', marginBottom: '20px' }} />
            <h2 style={{fontWeight: '300'}}>Welcome to ALS-RAC</h2>
            <p style={{textAlign: 'left'}}>{loginMessage ? loginMessage : defaultLoginMessage}</p>
            {
                showLoginButton && 
                    <Fragment>
                        <p style={{textAlign: 'left'}}>Click the button below and authenticate with your ORCID account to access the ALS Remote Access Server.</p>
                        <button className="primary-button" onClick={handleLogin} style={{
                            padding: '10px 20px',
                            fontSize: '16px',
                            color: 'white',
                            fontWeight: 'bold',
                            border: 'none',
                            borderRadius: '5px',
                            cursor: 'pointer',
                        }}>
                            Login with ORCID
                            
                        </button>
                    </Fragment>
            }
        </article>
    );
};

export default Login;